import { createContext } from '@lit-labs/context';

import type { FieldSize, FieldStatus } from './field.types';

export interface FieldContext {
	required?: boolean;
	status?: FieldStatus;
	size?: FieldSize;
}

const fieldContext = createContext<FieldContext>('field');

export default fieldContext;
